import { Badge, Tooltip } from "@knowtex-ai/components";
import { InfoCircle } from "iconoir-react";
import type { McRun } from "../../lib/mc";
import { runResult, statusBadge, type BadgeSpec } from "./format";

const SpecBadge = ({ spec }: { spec: BadgeSpec }) => (
  <Badge variant={spec.variant} tip={spec.tip}>
    {spec.label}
  </Badge>
);

export function RunStatusBadge({ status }: { status?: string }) {
  return <SpecBadge spec={statusBadge(status)} />;
}

/** A result as plain text, with an info icon that shows `tip` (e.g. what went wrong). */
export function ResultText({ label, tip }: { label: string; tip?: string }) {
  return (
    <span className="inline-flex items-center gap-1">
      {label}
      {tip && (
        <Tooltip label={tip}>
          <button
            type="button"
            aria-label={tip}
            className="inline-flex text-gray-500 hover:text-gray-700"
          >
            <InfoCircle width={14} height={14} aria-hidden />
          </button>
        </Tooltip>
      )}
    </span>
  );
}

/** The run's outcome, or "Error" (with the error behind an info icon) when something went wrong. */
export function RunResult({
  run,
}: {
  run: Pick<McRun, "status" | "error" | "outcome" | "findings">;
}) {
  const result = runResult(run);
  return result ? <ResultText {...result} /> : <span>—</span>;
}
